import { render, staticRenderFns } from "./accordionGroup.vue?vue&type=template&id=4fc5eec3&"
import script from "./accordionGroup.vue?vue&type=script&lang=js&"
export * from "./accordionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports